import getFallbackValueIfNull from '../../utils/getFallbackValueIfNull';
import LgpdAdvertisingViewState from '../../store/schema/LgpdAdvertisingViewState';
import { getOptionsForFeature } from 'owa-outlook-service-options';
import { getOptionsStore } from '../../store/Store';
import { LgpdAdsOptions, lgpdAdsOwsOptionsFeatureType } from 'owa-ads-ows-options';

export default function getLgpdOptions() {
    const savedOptions = getOptionsForFeature<LgpdAdsOptions>(lgpdAdsOwsOptionsFeatureType);

    const store = getOptionsStore();

    const options = store && (store.activeViewState as LgpdAdvertisingViewState);

    return {
        optInBit: getFallbackValueIfNull(options?.optInBit, savedOptions?.optInBit ?? null),
    };
}
